<div class="creator-page">

  <div class="page-header">
    <button mat-icon-button type="button" (click)="navigateTo('/templates')" matTooltip="Back to Templates">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="header-text">
      <h2 class="page-title">Create Resource Template</h2>
      <p class="page-subtitle">Select the type of resource template you'd like to create.</p>
    </div>
  </div>

  <div class="card-grid">

    <!-- ── Virtual Machine ──────────────────────────────────────── -->
    <mat-card class="resource-card" (click)="navigateTo('/create/virtual-machine')">
      <mat-card-content class="card-body">
        <mat-icon class="card-icon">computer</mat-icon>
        <h3 class="card-title">Virtual Machine</h3>
        <p class="card-desc">VM template with cloud provider, region, size, OS, and software settings.</p>
      </mat-card-content>
    </mat-card>

    <!-- ── User Account ─────────────────────────────────────────── -->
    <mat-card class="resource-card" (click)="navigateTo('/create/user-account')">
      <mat-card-content class="card-body">
        <mat-icon class="card-icon">manage_accounts</mat-icon>
        <h3 class="card-title">User Account</h3>
        <p class="card-desc">User account template with access level and Azure role assignment.</p>
      </mat-card-content>
    </mat-card>

  </div>

</div>
